import React from 'react'
import { TableCell } from '@mui/material'

const ProductionCellCollapsible = () => <TableCell />

export default ProductionCellCollapsible
